export const OPEN_MENU_LATERAL = 'accionOpenMenuLateral';
export const CLOSE_MENU_LATERAL = 'accionCloseMenuLateral';

export const accionOpenMenuLateral = () => ({
    type: OPEN_MENU_LATERAL
});

export const accionCloseMenuLateral = () => ({
    type: CLOSE_MENU_LATERAL,
});